import React from 'react'
import { breadcrumbDiscountPharmacies } from '../../constants'
import useStyles from './styles'
import logoPagueMenos from '@/assets/logo-pague-menos.png'
import { HeroWrapper } from '@/styles/rebranded/HeroWrapper'
import { Breadcrumbs, Text } from '@conexasaude/conexa-hero'
import { Link } from 'react-router-dom'
import CustomLayout from '@/components/RebrandedCustomLayout'

const DiscountPharmacies: React.FC = () => {
  const styles = useStyles()

  return (
    <HeroWrapper>
      <CustomLayout
        hasLayoutMenu
        layoutMenu={
          <Breadcrumbs.Root>
            {breadcrumbDiscountPharmacies?.map(item => (
              <Breadcrumbs.Item key={item.title} active={item.active}>
                <Link to={item.route}>{item.title}</Link>
              </Breadcrumbs.Item>
            ))}
          </Breadcrumbs.Root>
        }
      >
        <div css={styles.discountPharmaciesContainer}>
          <Text renderAs="h2">Desconto em farmácias</Text>
          <div css={styles.container}>
            <img src={logoPagueMenos} alt="Pague Menos" loading="lazy" />
            <Text renderAs="p">
              Você tem direito a descontos na rede de farmácias Pague Menos.
              Para usá-los, basta ir ao balcão da loja, informar o seu CPF e
              mostrar um documento de identificação com foto, além da receita
              médica.
            </Text>
            <div css={styles.containerText}>
              <Text renderAs="p">
                Localize a{' '}
                <a
                  href="https://www.paguemenos.com.br/nossas-lojas"
                  target="_blank"
                  rel="noreferrer"
                >
                  unidade mais próxima de você.
                </a>
              </Text>
            </div>
          </div>
        </div>
      </CustomLayout>
    </HeroWrapper>
  )
}

export default DiscountPharmacies
